// extracted by mini-css-extract-plugin
export default {"invalid":"MarcaUnidadEdit_invalid__JGJWj","spinnerContainer":"MarcaUnidadEdit_spinnerContainer__Oj1Ck"};